import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import BackOfficeLayout from "../../../components/backoffice-layout";
import ButtonComponent from "../../../components/button";
import IconReport from "../../../assets/images/icon-report.svg"
import { useNavigate, useParams } from "react-router-dom";
import SuccessModal from "../../../components/modal/success";
import LoadingModal from "../../../components/loading-modal";
import DropdownComponent from "../../../components/evaluation-form-components/dropdown";
import InputComponent from "../../../components/evaluation-form-components/input";
import IconDelete from "../../../assets/images/icon-delete.svg"
import CoreAPI from "../../../services/core";
import ResetPasswordModal from "../../../components/modal/reset-password";
import { getDuplicates, validatePassword } from "../../../utils/default";

const Container = styled.div`
    width: calc(100% - 32px);
    background-color: #FFFFFF;
    padding: 40px 16px;
    border-radius: 16px;

    .header-box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;

        .header-label {
            width: fit-content;
            color: #25368D;
            font-size: 20px;
            font-weight: 600;
            line-height: 29.9px;
            text-align: left;
            padding: 2px;
            border-width: 0px 0px 3px 0px;
            border-style: solid;
            border-color: #25368D;
        }
    }

    .data-box {
        display: flex;
        flex-direction: column;
        gap: 24px;
        margin-bottom: 24px;
    }

    .footer-bar {
        width: 100%;

        .button-box {
            width: fit-content;
            display: flex;
            gap: 16px;
            margin-right: 0px;
            margin-left: auto;
        }
    }
`;

const InformationBox = styled.div`

    &.border {
        border-width: 0px 0px 1px 0px;
        border-style: solid;
        border-color: #F2F2F2;
    }

    .label-header-info {
        color: #2A2A2A;
        font-size: 20px;
        font-weight: 500;
        line-height: 29.9px;
        text-align: left;
        margin-bottom: 20px;

        .icon {
            margin-bottom: 2px;
            cursor: pointer;
        }
    }

    ::placeholder {
        color: #838BB4;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        opacity: 1;
    }

    ::-ms-input-placeholder {
        color: #838BB4;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        opacity: 1;
    }
`;

const ResetPasswordBox = styled.div`
    width: 100%;

    .header-reset-label {
        color: #2A2A2A;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        margin-bottom: 16px;
    }

    .reset-label {
        width: fit-content;
        border-width: 0px 0px 2px 0px;
        border-style: solid;
        border-color: #25368D;
        color: #25368D;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        cursor: pointer;
    }
`;

function UserCreateUpdatePage() {
    const paramsRoute = useParams();
    const navigate = useNavigate();
    const [title, setTitle] = useState("เพิ่มสมาชิกใหม่");
    const [isEdit, setIsEdit] = useState(false);
    const [isResetPassword, setIsResetPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [detailModal, setDetailModal] = useState({
        title: "เพิ่มสมาชิกสำเร็จ",
        sub_title: "คุณสามารถดูข้อมูลบัญชีสมาชิกได้ที่หน้าหลัก",
        type: "success",
        button_label: "กลับหน้าหลัก",
        from: "",
    });
    const [listInformation, setListInformation] = useState([
        {
            id: "",
            firstname: "",
            lastname: "",
            username: "",
            password: "",
            department_id: null,
            list_division: [],
            division_id: null,
            is_error: false,
            is_error_password: false,
            label_error_password: "",
        }
    ]);
    const [listDepartment, setListDepartment] = useState([]);
    const [disableSave, setDisableSave] = useState(true);
    const [userProfile, setUserProfile] = useState(null);


    useEffect(() => {
        onInit();
    }, [])

    async function onInit() {
        setIsLoading(true);
        let _isEdit = false;
        let _profile = localStorage.getItem("profile");
        try {
            _profile = JSON.parse(_profile)
        } catch { }
        if (_profile?.user_username !== "superadmin" && _profile?.user_username !== "admin") {
            navigate(`/account`);
            return
        }
        // if (_profile?.user_division_id) {
        //     navigate(`/account`);
        //     return
        // }
        let response = null;
        if (paramsRoute?.id) {
            _isEdit = true;
            response = await onGetData(paramsRoute.id);
        }
        if (_profile) {
            setUserProfile(_profile)
            if (_profile.user_department_id) {
                await onGetDepartmentById(_profile.user_department_id)
            } else {
                await onGetAllDepertment()
            }
        } else if (response) {
            await onGetDepartmentById(response.department_id)
        }
        setIsEdit(_isEdit)
        setTitle(_isEdit ? "แก้ไขข้อมูลสมาชิก" : "เพิ่มสมาชิกใหม่")
        setIsLoading(false);
    }
    async function onGetData(id) {
        let response = null;
        try {
            response = await CoreAPI.userHttpService.userGetById(id)
        } catch { }
        if (response) {
            let list = [];
            let detail = {
                id: response.user_id,
                firstname: response.firstname,
                lastname: response.lastname,
                username: response.username,
                password: "",
                department_id: response.department_id,
                list_division: [],
                division_id: response.division_id,
                is_error: false,
                is_error_password: false,
                label_error_password: "",
            }
            const responseDivision = await onGetDivisionByDepertmentId(detail.department_id);
            detail.list_division = responseDivision;
            list.push(detail)
            setListInformation(list)
            const check = onCheckValidInput(list)
            setDisableSave(check)
        }
        return response;
    }
    async function onGetDepartmentById(id) {
        let response = [];
        try {
            response = await CoreAPI.userHttpService.userGetDepertmentById(id)
        } catch { }
        if (response) {
            let list = [];
            const detail = {
                id: response.department_id,
                label: response.department_name,
            }
            list.push(detail);
            response = [...list]
        }
        setListDepartment(response)
    }
    async function onGetAllDepertment() {
        let response = null;
        try {
            response = await CoreAPI.userHttpService.userGetAllDepertment()
        } catch { }
        if (response) {
            let list = [];
            if (Array.isArray(response)) {
                list = JSON.parse(JSON.stringify(response));
                list = list.map(x => {
                    const detail = {
                        id: x.department_id,
                        label: x.department_name,
                    }
                    return detail
                })
            }
            response = [...list]
        }
        setListDepartment(response)
    }
    async function onGetDivisionByDepertmentId(id) {
        let response = [];
        try {
            const body = {
                list: [id]
            }
            response = await CoreAPI.userHttpService.userGetDivisionByDepertmentId(body)
        } catch { }
        if (response) {
            if (Array.isArray(response)) {
                response = response.map(x => {
                    const detail = {
                        id: x.division_id,
                        label: x.division_name,
                    }
                    return detail
                })
                if (userProfile?.user_division_id) {
                    response = response.filter(x => x.id === userProfile?.user_division_id);
                }
            }
        }
        return response
    }
    async function onCreate() {
        let response = null;
        try {
            const body = {
                list: listInformation,
            };
            response = await CoreAPI.userHttpService.userCreateList(body)
        } catch { }
        if (response) {
            let detail = { ...detailModal }
            detail.title = response.success ? "เพิ่มสมาชิกสำเร็จ" : "เพิ่มสมาชิกล้มเหลว";
            detail.sub_title = response.success ? "คุณสามารถดูข้อมูลบัญชีสมาชิกได้ที่หน้าหลัก" : response.message === "username_duplicate" ? "Username ถูกใช้งานแล้ว" : "";
            detail.button_label = response.success ? "กลับหน้าหลัก" : "ตกลง";
            detail.type = response.success ? "success" : "fail";
            detail.from = "";
            setDetailModal(detail)
            setOpenModal(true)
            if (response.message === "username_duplicate") {
                let listUsername = response.data?.map(x => x.username);
                let list = JSON.parse(JSON.stringify(listInformation));
                list = list.map(x => {
                    x.is_error = listUsername.includes(x.username);
                    x.is_error_password = listUsername.includes(x.username);
                    x.label_error_password = "";
                    return x;
                })
                setListInformation(list)
            }
        }
    }
    async function onUpdate(param) {
        let response = null;
        try {
            const body = {
                user_id: param?.id,
                firstname: param?.firstname,
                lastname: param?.lastname,
                username: param?.username,
                department_id: param?.department_id || null,
                division_id: param?.division_id || null,
            };
            response = await CoreAPI.userHttpService.userUpdate(body)
        } catch { }
        if (response) {
            let detail = { ...detailModal }
            detail.title = response.success ? "แก้ไขสมาชิกสำเร็จ" : "แก้ไขสมาชิกล้มเหลว";
            detail.sub_title = response.success ? "คุณสามารถดูข้อมูลบัญชีสมาชิกได้ที่หน้าหลัก" : response.message === "username_duplicate" ? "Username ถูกใช้งานแล้ว" : "";
            detail.button_label = response.success ? "กลับหน้าหลัก" : "ตกลง";
            detail.type = response.success ? "success" : "fail";
            detail.from = "";
            setDetailModal(detail)
            setOpenModal(true)
            if (response.message === "username_duplicate") {
                let list = JSON.parse(JSON.stringify(listInformation));
                list = list.map(x => {
                    x.is_error = true;
                    x.is_error_password = true;
                    x.label_error_password = "";
                    return x;
                })
                setListInformation(list)
            }
        }
    }
    async function onResetPassword(param) {
        let response = null;
        try {
            const body = {
                user_id: param?.id,
                password: param?.password,
            };
            response = await CoreAPI.userHttpService.userResetPassword(body)
        } catch { }
        return response;
    }
    function onCheckValidInput(list) {
        let _isEdit = false;
        if (paramsRoute?.id) {
            _isEdit = true;
        }
        let model = list.find(x => {
            let check = false;
            if (!x.firstname
                || !x.lastname
                || !x.username) {
                check = true;
            }
            if (!x.password) {
                if (!_isEdit) {
                    check = true;
                }
            }
            if (!x.department_id) {
                check = true;
            }
            if (!x.division_id) {
                if (userProfile?.user_division_id) {
                    check = true;
                }
            }

            return check;
        })
        return model ? true : false;
    }

    function handleAddUser() {
        let list = JSON.parse(JSON.stringify(listInformation));
        let detail = {
            firstname: "",
            lastname: "",
            username: "",
            password: "",
            department_id: null,
            division_id: null,
        };
        list.push(detail);
        setListInformation(list);
        setDisableSave(true)
    }
    function handleRemoveUser(index) {
        let list = JSON.parse(JSON.stringify(listInformation));
        list.splice(index, 1);
        setListInformation(list);
        const check = onCheckValidInput(list)
        setDisableSave(check)
    }
    async function handleChangeInformation(key, value, index) {
        let list = JSON.parse(JSON.stringify(listInformation));
        list[index][key] = value;
        list = list.map(x => {
            x.is_error = false;
            if (!x.label_error_password) {
                x.is_error_password = false;
            }
            return x;
        })
        if (key === "department_id") {
            list[index].division_id = null;
            const response = await onGetDivisionByDepertmentId(value)
            list[index].list_division = response;
        }
        if (key === "password") {
            list[index].is_error_password = false;
            list[index].label_error_password = "";
        }
        setListInformation(list)
        const check = onCheckValidInput(list)
        setDisableSave(check)
    }
    async function handleConfirm() {
        setIsLoading(true)
        // ========== ========== ========== ==========
        if (!isEdit) {
            let checkPassword = true;
            let list = JSON.parse(JSON.stringify(listInformation));
            let listUsername = list.map(x => x.username);
            let listUsernameDup = getDuplicates(listUsername);
            for (let item of list) {
                if (item.password) {
                    if (!validatePassword(item.password)) {
                        item.is_error_password = true;
                        item.label_error_password = "รหัสผ่านต้อง 8 ตัวอักษรขึ้นไป และมีทั้งตัวอักษร กับตัวเลข";
                        checkPassword = false;
                    } else {
                        item.is_error_password = false;
                        item.label_error_password = "";
                    }
                }
            }
            if (!checkPassword) {
                setListInformation(list);
                setIsLoading(false)
                return;
            }
            if (listUsernameDup.length > 0) {
                list = list.map(x => {
                    if (listUsernameDup.includes(x.username)) {
                        x.is_error = true;
                        x.is_error_password = true;
                    }
                    return x;
                })
                setListInformation(list);
                setIsLoading(false)
                return;
            }
        }
        // ========== ========== ========== ==========
        if (isEdit) {
            let detail = {
                ...listInformation[0]
            }
            await onUpdate(detail);
        } else {
            await onCreate();
        }
        setIsLoading(false)
    }
    function handleBack(param) {
        if (param === "modal") {
            if (detailModal.type === "success") {
                if (detailModal.from === "reset") {
                    setOpenModal(false)
                } else {
                    navigate(`/user-management/list-view`);
                }
            } else {
                setOpenModal(false)
            }
        } else if (param === 'bar') {
            navigate(`/user-management/list-view`);
        } else if (param === 'bar') {
            setOpenModal(false)
        }
    }
    async function handleConfirmResetPassword(param) {
        setIsLoading(true)
        let detail = {
            ...listInformation[0],
            password: param,
        }
        if (detail.password) {
            const response = await onResetPassword(detail);
            let _detailModal = { ...detailModal }
            _detailModal.title = response?.success ? "เปลี่ยนรหัสผ่านสำเร็จ" : "เปลี่ยนรหัสผ่านล้มเหลว";
            _detailModal.sub_title = "";
            _detailModal.button_label = "ตกลง";
            _detailModal.type = response?.success ? "success" : "fail";
            _detailModal.from = "reset";
            setDetailModal(_detailModal)
            setOpenModal(true)
            setIsResetPassword(false)
        }
        setIsLoading(false)
    }

    return (
        <BackOfficeLayout>
            <LoadingModal open={isLoading} />
            <SuccessModal
                open={openModal}
                onConfirm={(e) => handleBack("modal")}
                title={detailModal.title}
                subTitle={detailModal.sub_title}
                type={detailModal.type}
                buttonLabel={detailModal.button_label}
            />
            <ResetPasswordModal
                open={isResetPassword}
                onConfirm={handleConfirmResetPassword}
                onBack={(e) => setIsResetPassword(false)}
                title={"เปลี่ยนรหัสผ่าน"}
                labelBack={"ยกเลิก"}
                labelConfirm={"ยืนยัน"}
            />
            <Container>
                <div className="header-box vertical-center">
                    <div className="header-label">
                        {title}
                    </div>
                    {!isEdit &&
                        <ButtonComponent
                            label={"เพิ่มรายการ"}
                            variant={"primary"}
                            icon={IconReport}
                            sceenSize={"lg"}
                            style={{ width: "200px", maxWidth: "200px", minWidth: "200px" }}
                            onClick={handleAddUser}
                        />
                    }
                </div>
                <div className="data-box">
                    {listInformation.map((value, index) => {
                        return (
                            <InformationBox key={index}
                                className={`${listInformation.length > 1 && (index + 1) < listInformation.length ? "border" : ""}`}>
                                <div className="label-header-info vertical-center">
                                    ข้อมูลสมาชิก {listInformation.length > 1 ? `(${index + 1})` : ""}
                                    {listInformation.length > 1 &&
                                        <img className="icon" alt="img" src={IconDelete} onClick={(e) => handleRemoveUser(index)} />
                                    }
                                </div>
                                <div className="vertical-center" style={{ gap: "24px" }}>
                                    <InputComponent
                                        label={"ชื่อ"}
                                        placeholder={"กรุณากรอกชื่อ"}
                                        styleInput={{ border: "1px solid #B5B5B5" }}
                                        value={value.firstname}
                                        isError={value.is_error}
                                        onInput={(e) => { handleChangeInformation("firstname", e, index) }}
                                    />
                                    <InputComponent
                                        label={"นามสกุล"}
                                        placeholder={"กรุณากรอกนามสกุล"}
                                        styleInput={{ border: "1px solid #B5B5B5" }}
                                        value={value.lastname}
                                        isError={value.is_error}
                                        onInput={(e) => { handleChangeInformation("lastname", e, index) }}
                                    />
                                </div>
                                <div className="vertical-center" style={{ gap: "24px" }}>
                                    <div style={{ width: "calc(50% - 12px)" }}>
                                        <DropdownComponent
                                            label={"ฝ่าย"}
                                            placeholder={"กรุณาเลือกฝ่าย"}
                                            list={listDepartment}
                                            value={{ id: value.department_id }}
                                            isError={value.is_error}
                                            onSelect={(e) => { handleChangeInformation("department_id", e?.id, index) }}
                                        />
                                    </div>
                                    <div style={{ width: "calc(50% - 12px)" }}>
                                        <DropdownComponent
                                            label={"กอง"}
                                            placeholder={"กรุณาเลือกกอง"}
                                            list={value.list_division}
                                            value={{ id: value.division_id }}
                                            isError={value.is_error}
                                            onSelect={(e) => { handleChangeInformation("division_id", e?.id, index) }}
                                        />
                                    </div>
                                </div>
                                <div className="label-header-info">บัญชีผู้ใช้ และรหัสผ่าน</div>
                                <div style={{ display: "flex", gap: "24px" }}>
                                    <InputComponent
                                        label={"Username"}
                                        placeholder={"กรุณากรอก Username"}
                                        styleInput={{ border: "1px solid #B5B5B5" }}
                                        value={value.username}
                                        isError={value.is_error}
                                        onInput={(e) => { handleChangeInformation("username", e, index) }}
                                    />

                                    {isEdit ?
                                        <ResetPasswordBox>
                                            <div className="header-reset-label">Password</div>
                                            <div className="reset-label"
                                                onClick={(e) => setIsResetPassword(true)}
                                            >
                                                เปลี่ยนรหัสผ่าน
                                            </div>
                                        </ResetPasswordBox>
                                        :
                                        <InputComponent
                                            label={"Password"}
                                            placeholder={"กรุณากรอก Password"}
                                            styleInput={{ border: "1px solid #B5B5B5" }}
                                            type={"password"}
                                            value={value.password}
                                            isError={value.is_error_password}
                                            labelError={value.label_error_password}
                                            onInput={(e) => { handleChangeInformation("password", e, index) }}
                                        />
                                    }
                                </div>
                            </InformationBox>
                        )
                    })}
                </div>
                <div className="footer-bar">
                    <div className="button-box">
                        <ButtonComponent
                            label={"ยกเลิก"}
                            variant={"secondary"}
                            sceenSize={"lg"}
                            style={{ width: "200px", maxWidth: "200px", minWidth: "200px" }}
                            onClick={(e) => handleBack("bar")}
                        />
                        <ButtonComponent
                            disable={disableSave}
                            label={"ยืนยัน"}
                            variant={"primary"}
                            sceenSize={"lg"}
                            style={{ width: "200px", maxWidth: "200px", minWidth: "200px" }}
                            onClick={handleConfirm}
                        />
                    </div>
                </div>
            </Container>
        </BackOfficeLayout>
    )
}

export default UserCreateUpdatePage;